export const contentProductMountable = {
	labelStep: "Etapa",
	labelItems: "ELEMENTOS",
	labelTitleInfo: "INFORMACIONES",
	addNewItem: "Agregar otro elemento",
	fields: {
		labelRequiredField: "Campo obligatorio",
		title: "Título",
		pricing: "Precio",
		max: {
			title: "Máximo",
			errorMessage: {
				notNullable: "El valor máximo no puede ser igual a cero",
				cannotLessMinimum: "Valor máximo no puede ser menor que valor mínimo",
			},
		},
		min: {
			title: "Mínimo",
			errorMessage: {
				cannotGreaterMaximum: "Valor mínimo no puede ser mayor que valor máximo",
			},
		},
		item: "Elemento",
		SelectableMaxQuantity: "Cantidad máx seleccionable",
		AmountSlaughtered: {
			title: "Cantidad descontada",
			errorMessage: {
				notNullable: "Cantidad descontada debe ser mayor que cero",
			},
		},
		price: "Valor",
	},
	modalToggleStatusItem: {
		activeItem: "Activar elemento montable",
		deactiveItem: "Desactivar elemento montable",
		warningMessage: {
			active:
				"¿Desea activar este elemento en los demás productos montables que lo componen?",
			deactive:
				"¿Desea desactivar este elemento en los demás productos montables que lo componen?",
		},
	},
	modalWarningMontable: {
		excludeStep: "Eliminar etapa",
		excludeItem: "Eliminar elemento",
		warningMessage: {
			exludeLastStep: "No es posible eliminar todas las etapas de un producto montable.",
			excludeLastItem:
				"No es posible eliminar todos los elementos de un producto montable.",
		},
	},
};
